/**
 * Мутабельная ссылка на токен текущей сессии.
 * Нужна api-клиенту (вне Effector-графа); синхронизируется из session/model.
 */
let currentToken: string | null = null;

export function getSessionToken(): string | null {
  return currentToken;
}

export function setSessionToken(token: string | null): void {
  currentToken = token;
}
